import { render, staticRenderFns } from "./WebChapterTemplate.vue?vue&type=template&id=2391080a&scoped=true"
import script from "./WebChapterTemplate.vue?vue&type=script&lang=js"
export * from "./WebChapterTemplate.vue?vue&type=script&lang=js"
import style0 from "./WebChapterTemplate.vue?vue&type=style&index=0&id=2391080a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2391080a",
  null
  
)

export default component.exports